import { Link } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';
import { ArrowRight, Home } from 'lucide-react';

export const NotFoundPage = () => {
  return (
    <>
      <SEOHead
        title="Page Not Found | Hexalogix Automation"
        description="The page you are looking for does not exist. Return to Hexalogix Automation homepage."
        robots="noindex, nofollow"
      />
      <div className="min-h-screen bg-[#0A0F1E] flex flex-col items-center justify-center px-4 text-center">
        <div className="text-[#0057B8] text-[120px] md:text-[180px] font-black leading-none select-none opacity-20">
          404
        </div>
        <div className="-mt-8 md:-mt-12">
          <h1 className="text-3xl md:text-4xl font-black text-white mb-4">Page Not Found</h1>
          <p className="text-gray-400 text-lg max-w-md mx-auto mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <button className="inline-flex items-center gap-2 bg-[#0057B8] hover:bg-[#003D82] text-white font-bold px-8 py-4 text-base tracking-wide transition-all duration-200 group">
                <Home className="w-4 h-4" />
                Go to Homepage
              </button>
            </Link>
            <Link to="/contact">
              <button className="inline-flex items-center gap-2 border-2 border-white/30 hover:border-white text-white font-semibold px-8 py-4 text-base tracking-wide transition-all duration-200 hover:bg-white/10 group">
                Contact Us
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
